import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=4681de86"
import script from "./nav.vue?vue&type=script&lang=ts"
export * from "./nav.vue?vue&type=script&lang=ts"
import style0 from "./nav.vue?vue&type=style&index=0&id=4681de86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports